import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import banner2 from '../assets/banner2.png';
// Reusable Accordion Item Component
const FAQItem = ({ question, answer }: { question: string; answer: string }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-100 last:border-none py-3">
      <button
        className="w-full flex justify-between items-center text-left gap-4 group"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={`text-[17px] md:text-[19px] font-medium transition-colors duration-200 ${isOpen ? 'text-gray-800' : 'text-gray-800 '}`}>
          {question}
        </span>
        <div className="flex-shrink-0 flex items-center justify-center w-5 h-5">
          <span className={`relative w-4 h-4 transition-transform duration-300 ${isOpen ? "rotate-90" : ""}`}>
            {/* Vertical bar (Always stays, but rotates with parent to become the minus) */}
            <span className="absolute left-1/2 top-0 h-4 w-[2px] bg-red-700 transform -translate-x-1/2 transition-all duration-300" />
            
            {/* Horizontal bar (Fades out when open) */}
            <span
              className={`absolute top-1/2 left-0 w-4 h-[2px] bg-red-700 transform -translate-y-1/2 transition-opacity duration-300 ${
                isOpen ? "opacity-0" : "opacity-100"
              }`}
            />
          </span>
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] mt-3' : 'max-h-0'}`}>
     <div className="text-gray-600 text-[15px] md:text-[17px] leading-[1.45] pb-2">
  {answer.split('\n').map((line, i) => (
    <div
      key={i}
      className={
        line.trim() === ''
          ? 'h-[10px]'        // 👈 SMALL controlled gap
          : ''
      }
    >
      {line}
    </div>
  ))}
</div>

      </div>
    </div>
  );
};

const FAQs = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [hash]);

  return (
    <div className="bg-[#faf9f6] min-h-screen">
      {/* ================= HEADER BANNER ================= */}
  <section
  className="relative py-16 md:py-24 text-center overflow-hidden"
  style={{
    backgroundImage: `url(${banner2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <h3 className="relative z-10 font-syne text-[28px] md:text-[40px] text-slate-900 tracking-tight font-medium">
    FAQ
  </h3>

 <div
  className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
  style={{
    background:
      "linear-gradient(to bottom, rgba(250, 249, 246, 0) 0%, rgba(250, 249, 246, 0.35) 40%, rgba(250, 249, 246, 0.7) 70%, rgba(250, 249, 246, 1) 100%)",
  }}
/>
</section>

{/* Wrap your existing sections in this new container div */}
<div className="max-w-5xl mx-auto px-6 lg:px-12 pb-24 mt-16 relative z-20">
        

        {/* --- OUR COMPANY --- */}
        <section id="our-company" className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
         <div className="border-b border-gray-100 pb-3 mb-4"> 
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      OUR COMPANY
    </h4>
  </div>
          <div className="divide-y divide-gray-50">
            <FAQItem question="Who is DreamLadder Capital, and what makes us different from other financial advisors?"   answer={`DreamLadder Capital is an AMFI-registered Mutual Fund Distributor and an APMI-registered PMS Distribution entity offering solutions across mutual funds, equities, PMS, AIFs, insurance, and legacy planning.

What sets us apart is our focus on disciplined portfolio construction, goal-based investing, and long-term wealth creation, supported by strong governance and a client-first approach.`}/>
            <FAQItem question="Are you SEBI regulated?" answer="Yes. DreamLadder Capital operates fully within the SEBI regulatory framework. We are AMFI-registered mutual fund distributors and APMI-registered PMS distributors. All products and services are offered through SEBI-registered and regulated entities, ensuring compliance, transparency, and investor protection.
" />
            <FAQItem question="How do you ensure the safety of client investments?" answer="We operate only through regulated platforms and follow robust security protocols, including bank-grade encryption, multi-factor authentication, and periodic system audits, to safeguard client data and transactions." />
            <FAQItem question="What kind of clients do you serve?" answer="We work with individuals, families, HNIs, NRIs/OCIs, and corporates, offering structured solutions suited to diverse financial needs and objectives.

" />
            <FAQItem question="How do I get started with DreamLadder Capital?" answer="Getting started is simple—complete your KYC, onboard through our platform, and our team will assist you through each step of the investment process." />
          </div>
        </section>

        {/* --- EQUITY --- */}
        <section id="equity" className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
         <div className="border-b border-gray-100 pb-3 mb-4"> 
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      EQUITY
    </h4>
  </div>
          <div className="divide-y divide-gray-50">
            <FAQItem question="What is equity investment and how does it work?" answer="Equity investing involves buying shares of companies to participate in their growth and earnings. While returns can be higher over time, equity investments are subject to market fluctuations." />
            <FAQItem question="How do you structure client portfolios?" answer="Client portfolios are structured based on individual risk profiles, financial goals, investment horizon, and liquidity needs. We facilitate allocation across suitable investment products such as mutual funds, PMS, AIFs, and other financial instruments through a disciplined asset allocation framework focused on long-term wealth creation." />
            <FAQItem question="What are the risks involved in equity investing?" answer="Equity investments are exposed to market volatility and price movements. However, over the long term, equities have the potential to deliver superior returns compared to many other asset classes." />
            <FAQItem question="Is there a minimum amount required to start investing in equities?" answer="Yes. Equity investments through PMS and AIF structures are subject to the minimum investment limits prescribed by SEBI for these products." />
            <FAQItem question="How does DreamLadder Capital monitor equity portfolios?" answer="Equity portfolios are managed and monitored by the respective fund managers of the PMS and AIF strategies selected by the client. DreamLadder Capital facilitates periodic reviews, reporting, and communication to help clients track portfolio progress and stay aligned with their long-term objectives." />
          </div>
        </section>

        <section
  id="investment-overview"
  className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
>
  <div className="border-b border-gray-100 pb-3 mb-4">
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      INVESTMENT
    </h4>
  </div>

  <div className="divide-y divide-gray-50">
    <FAQItem
      question="What investment options are available with DreamLadder Capital?"
      answer="We facilitate access to a wide range of investment products, including mutual funds, equities, PMS, AIFs, insurance, structured products, and legacy planning solutions, through regulated platforms and entities."
    />

    <FAQItem
      question="How is my risk profile understood before investing?"
      answer="Your financial objectives, investment horizon, and risk preferences are understood through structured discussions and standard risk-profiling frameworks to help align suitable investment options."
    />

    <FAQItem
      question="Can I invest online through your platform?"
      answer="Yes. Our platform supports secure, fully digital onboarding and transaction execution, with assistance available throughout the process."
    />

    <FAQItem
      question="How often should investments be reviewed?"
      answer="Periodic reviews—typically on a quarterly basis—help track progress and ensure alignment with changing market conditions and personal circumstances."
    />
  </div>
</section>


        {/* --- MUTUAL FUNDS --- */}
        <section id="mutual-funds" className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <div className="border-b border-gray-100 pb-3 mb-4"> 
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      MUTUAL FUNDS
    </h4>
  </div>
          <div className="divide-y divide-gray-50">
            <FAQItem question="What are mutual funds, and how do they work?" answer="Mutual funds pool money from investors to invest in stocks, bonds, or other assets, managed by professional fund managers." />
            <FAQItem question="What is the difference between SIP (Systematic Investment Plan) and lump sum investment?" answer="Lump Sum: Invest a larger amount at once (works best when markets are favorable). SIP: Invest small, fixed amounts regularly (disciplined approach)." />
             <FAQItem question="How do I choose the right mutual fund scheme?" answer="The right scheme depends on your financial goals, risk appetite, and time horizon. Our advisors help you pick the best fit." />
            <FAQItem question="Are there any lock-in periods or exit loads in mutual funds?" answer="ELSS funds have a 3-year lock-in. Some funds may have exit loads if redeemed within a certain period." />
            <FAQItem question="How are mutual fund returns taxed?" answer={`Equity funds: Short-term gains (<1 year) taxed at 20%, long-term gains (>1 year) taxed at 12.5% above ₹1.25 lakh.
            
Debt funds: Taxed as per your income slab.`} />
          </div>
        </section>

        {/* --- INSURANCE --- */}
        <section id="insurance" className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
         <div className="border-b border-gray-100 pb-3 mb-4"> 
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      INSURANCE
    </h4>
  </div>
          <div className="divide-y divide-gray-50">
            <FAQItem question="What types of insurance plans are available through DreamLadder Capital?" answer="We facilitate access to term, health, life, and investment-linked insurance plans offered by leading, regulated insurers." />
            <FAQItem question="How is the required insurance coverage determined?" answer="Coverage needs are understood based on factors such as income, liabilities, family responsibilities, and long-term financial objectives, using standard assessment frameworks." />
            <FAQItem question="What is the difference between term insurance and investment-linked insurance?" answer="Term Insurance: Provides pure life cover with high protection at a relatively low cost. Investment-Linked Insurance: Combines insurance protection with a savings or investment component." />
            <FAQItem question="How does the claim settlement process work?" answer="In the event of a claim, the policyholder or nominee submits the required documents directly to the insurer. DreamLadder Capital assists with coordination and follow-ups to help ensure a smooth and timely settlement process." />
          </div>
        </section>

        <section
  id="structured-products"
  className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
>
  <div className="border-b border-gray-100 pb-3 mb-4">
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      STRUCTURED PRODUCTS
    </h4>
  </div>

  <div className="divide-y divide-gray-50">
    <FAQItem
      question="What are structured products and who are they suitable for?"
      answer="Structured products are customised investment solutions that combine instruments such as equities, debt, and derivatives. They are generally suited for investors seeking defined payoff structures with a controlled risk profile, based on specific market outcomes."
    />

    <FAQItem
      question="How do structured products differ from mutual funds or PMS?"
      answer="Unlike mutual funds or PMS that follow market performance, structured products offer pre-defined payoffs linked to market conditions, giving risk-adjusted outcomes."
    />

    <FAQItem
      question="What are the risks and benefits of structured products?"
      answer="Benefits: Capital protection (in some products), tailored returns, diversification. Risks: Market dependency, complexity, and lower liquidity compared to traditional funds."
    />

    <FAQItem
      question="What is the minimum investment amount?"
      answer="Typically, structured products require a minimum investment of ₹25–50 lakhs, depending on the product."
    />

    <FAQItem
      question="Are structured products regulated in India?"
      answer="Yes. Structured products in India are regulated by SEBI and issued by authorized financial institutions."
    />
  </div>
</section>


        {/* --- PMS / AIF --- */}
        <section
  id="pms-aif"
  className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
>
  <div className="border-b border-gray-100 pb-3 mb-4">
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      PMS / AIF
    </h4>
  </div>

  <div className="divide-y divide-gray-50">
    <FAQItem
      question="What is Portfolio Management Service (PMS), and how is it different from mutual funds?"
      answer="PMS offers personalized portfolios managed by experts, unlike mutual funds where money is pooled. PMS gives direct ownership of securities and higher customization."
    />

    <FAQItem
      question="What are Alternative Investment Funds (AIFs)?"
      answer="AIFs are privately pooled funds investing in assets like private equity, venture capital, hedge funds, or debt, designed for sophisticated investors."
    />

    <FAQItem
      question="Who is eligible to invest in PMS and AIF?"
      answer="High-net-worth individuals (HNIs) and institutions who meet SEBI’s eligibility and minimum investment criteria."
    />

    <FAQItem
      question="What is the minimum investment required?"
      answer="PMS: ₹50 lakhs | AIFs: ₹1 crore"
    />

    <FAQItem
      question="How does DreamLadder select PMS/AIF managers?"
      answer="We evaluate managers based on track record, investment philosophy, risk management, and alignment with client goals."
    />
  </div>
</section>


        {/* --- LEGACY PLANNING --- */}
        <section
  id="legacy-planning"
  className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
>
  <div className="border-b border-gray-100 pb-3 mb-4">
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      LEGACY PLANNING
    </h4>
  </div>

  <div className="divide-y divide-gray-50">
    <FAQItem
      question="What is legacy planning, and why is it important?"
      answer="Legacy planning ensures that your wealth is transferred smoothly to the next generation in a structured and legally recognized manner. It helps minimize potential disputes, administrative delays, and tax inefficiencies while preserving family harmony."
    />

    <FAQItem
      question="How can DreamLadder assist with estate or succession planning?"
      answer="We facilitate coordination with legal and tax professionals for the creation of wills, trusts, nominee structures, and tax-efficient transfer mechanisms. Our role is to help structure your financial assets in alignment with your wishes and long-term family objectives."
    />

    <FAQItem
      question="Can NRIs/OCIs undertake legacy planning in India?"
      answer="Yes. NRIs and OCIs can structure the transfer of their Indian assets in accordance with applicable Indian laws. Cross-border considerations may require coordination with legal and tax professionals in relevant jurisdictions."
    />

    <FAQItem
      question="What is the difference between a will and a trust?"
      answer="A Will becomes effective after the individual’s lifetime and may require probate in certain jurisdictions.
A Trust can be structured to operate during one’s lifetime or thereafter and may offer greater control, continuity, and privacy in asset distribution."
    />

    <FAQItem
      question="How do taxes impact inheritance in India?"
      answer="Currently, India does not levy inheritance or estate tax. However, any income generated from inherited assets is taxable in the hands of the recipient as per applicable tax laws."
    />
  </div>
</section>

<section
  id="payment-related"
  className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
>
  <div className="border-b border-gray-100 pb-3 mb-4">
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      PAYMENT RELATED
    </h4>
  </div>

  <div className="divide-y divide-gray-50">
    <FAQItem
      question="What payment methods are available for investment?"
      answer="Investments can be made through net banking, UPI, NEFT/RTGS, registered mandates, or cheques, depending on the product and platform used."
    />

    <FAQItem
      question="Is online payment secure?"
      answer="Yes. Transactions are processed through authorized banking channels and secure investment platforms with industry-standard encryption and regulatory safeguards."
    />

    <FAQItem
      question="Do you accept payments?"
      answer="We do not receive or hold client funds. For mutual fund transactions executed through the exchange platform, payments are routed directly from the investor’s registered bank account to the clearing corporation (ICCL), which subsequently settles funds with the respective AMCs. For PMS and AIF investments, payments are made directly by the investor to the respective fund house or portfolio manager, as per the prescribed process."
    />

    <FAQItem
      question="Are there any hidden charges or transaction fees?"
      answer="No. All applicable charges, commissions, or fees (where relevant) are transparently disclosed in accordance with regulatory requirements."
    />

  </div>
</section>

<section
  id="account-creation"
  className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
>
  <div className="border-b border-gray-100 pb-3 mb-4">
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      ACCOUNT CREATION
    </h4>
  </div>

  <div className="divide-y divide-gray-50">
    <FAQItem
      question="How do I create an account with DreamLadder Capital?"
      answer="You can create an account by filling out a simple online application form on our website."
    />

    <FAQItem
      question="What documents are required for KYC?"
      answer="You’ll need PAN, Aadhaar, address proof, bank details, and a passport-size photo. NRIs require additional documents like passport and visa."
    />

    <FAQItem
      question="How long does the account opening process take?"
      answer="Usually 24–48 hours, once all documents are verified."
    />

    <FAQItem
      question="Can I open a joint investment account?"
      answer="Yes. We allow joint accounts with up to three holders."
    />

    <FAQItem
      question="Is account creation possible online, or do I need to visit physically?"
      answer="The process is 100% online—no physical visit required."
    />
  </div>
</section>


        {/* --- NRI / OCI --- */}
       <section
  id="nri-oci"
  className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
>
  <div className="border-b border-gray-100 pb-3 mb-4">
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      NRI / OCI
    </h4>
  </div>

  <div className="divide-y divide-gray-50">
    <FAQItem
      question="Can NRIs/OCIs invest in Indian equities and mutual funds?"
      answer="Yes. NRIs/OCIs can invest in Indian equities, mutual funds, bonds, PMS, and AIFs under RBI and SEBI guidelines."
    />

    <FAQItem
      question="What accounts are required for NRI investing (NRE/NRO/FCNR)?"
      answer="NRE Account – Repatriable investments (funds transferable abroad). NRO Account – Non-repatriable Indian income (like rent/dividends). FCNR Account – Foreign currency deposits."
    />

    <FAQItem
      question="Are there any tax implications for NRIs investing in India?"
      answer="Yes. Capital gains and income are taxable in India, with provisions for DTAA (Double Taxation Avoidance Agreements) to prevent double taxation."
    />

    <FAQItem
      question="Can NRIs invest in PMS, AIF, or structured products?"
      answer="Yes, NRIs can invest, subject to eligibility and regulatory approvals for specific products."
    />

    <FAQItem
      question="How does DreamLadder assist NRIs in managing their wealth remotely?"
      answer="We support NRIs in managing their Indian investments by facilitating documentation, banking coordination, and compliance requirements, enabling seamless execution from abroad."
    />
  </div>
</section>


        {/* --- US / CANADA --- */}
       <section
  id="indians-us-canada"
  className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
>
  <div className="border-b border-gray-100 pb-3 mb-4">
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      INDIANS IN US / CANADA
    </h4>
  </div>

  <div className="divide-y divide-gray-50">
    <FAQItem
      question="Can Indians living in the US/Canada invest in Indian mutual funds?"
      answer="Yes, but options are limited as many AMCs restrict US/Canada investors due to compliance rules."
    />

    <FAQItem
      question="What are the regulatory restrictions for US/Canada residents?"
      answer="Investments must comply with FATCA (Foreign Account Tax Compliance Act) and Canadian regulatory norms, which restrict certain fund houses."
    />

    <FAQItem
      question="Do I need special documentation (like FATCA compliance)?"
      answer="Yes. You must complete FATCA/CRS declarations and provide proof of overseas residency."
    />

    <FAQItem
      question="What investment options are available for Indians in North America?"
      answer="Select mutual funds open to US/Canada investors. Direct equities through NRE/NRO accounts. PMS, AIF, and bonds (where regulations permit)."
    />

    <FAQItem
      question="How does DreamLadder ensure compliance with US/Canada tax rules?"
      answer="We conduct strict KYC checks, FATCA reporting, and tax-aligned structuring, ensuring your investments stay fully compliant."
    />
  </div>
</section>

<section
  id="regulations-compliance"
  className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
>
  <div className="border-b border-gray-100 pb-3 mb-4">
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      REGULATIONS & COMPLIANCE
    </h4>
  </div>

  <div className="divide-y divide-gray-50">
    <FAQItem
      question="Is DreamLadder Capital SEBI regulated?"
      answer="Yes. DreamLadder Capital operates fully within the SEBI regulatory framework. We are AMFI-registered mutual fund distributors and APMI-registered PMS distributors. All products and services are offered through SEBI-registered and regulated entities, ensuring compliance, transparency, and investor protection."
    />

    <FAQItem
      question="How do you ensure compliance with Indian financial regulations?"
      answer="We operate in accordance with SEBI, AMFI, APMI, and RBI guidelines, supported by internal compliance processes designed to maintain transparency, suitability, and regulatory adherence."
    />

    <FAQItem
      question="What safety measures protect my investments from fraud?"
      answer="Investor funds are held directly in the investor’s name with the respective AMCs, custodians, PMS, or AIF providers. DreamLadder Capital does not receive or hold client funds. Transactions are processed through authorized banking and regulated platforms."
    />

    <FAQItem
      question="How is investor grievance redressal handled?"
      answer="Clients may reach our designated support and compliance contact for assistance. Additionally, grievances related to mutual funds can be escalated through the SEBI SCORES platform, in accordance with regulatory procedures."
    />

    <FAQItem
      question="Do you provide audited performance reports?"
      answer="Yes. Transaction confirmations and portfolio statements are issued by the respective AMCs, PMS, or AIF providers. We facilitate consolidated portfolio reviews to help clients stay informed."
    />
  </div>
</section>

<section
  id="taxation-returns"
  className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
>
  <div className="border-b border-gray-100 pb-3 mb-4">
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      TAXATION & RETURNS
    </h4>
  </div>

  <div className="divide-y divide-gray-50">
    <FAQItem
      question="How are equity and mutual fund gains taxed in India?"
     answer={`Listed Equity Shares & Equity Mutual Funds:
• Short-Term Capital Gains (≤1 year): 20%
• Long-Term Capital Gains (>1 year): 12.5% on gains exceeding ₹1.25 lakh in a financial year
 
Debt Mutual Funds:
• Capital gains are taxed as per the investor’s applicable income tax slab rate.`}



    />

    <FAQItem
      question="What is the difference between short-term and long-term capital gains?"
      answer="Short-Term: Holding ≤1 year (for equity). Taxed at higher rates. Long-Term: Holding >1 year (for equity). Taxed at concessional rates."
    />

    <FAQItem
      question="Are dividends taxable?"
      answer="Yes. Dividends from equities and mutual funds are taxed at your income slab rate."
    />

    <FAQItem
      question="How are NRIs/OCIs taxed on Indian investments?"
      answer="Capital gains on listed equity and mutual funds are taxed as per applicable Indian tax laws. Tax is generally deducted at source (TDS), and relief may be available under relevant Double Taxation Avoidance Agreements (DTAA), subject to eligibility.
"
    />

    <FAQItem
      question="Does DreamLadder provide tax planning and filing support?"
      answer="Yes. We provide tax-efficient strategies, investment structuring, and filing assistance through our expert partners."
    />
  </div>
</section>

<section
  id="digital-security-cyber-safety"
  className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
>
  <div className="border-b border-gray-100 pb-3 mb-4">
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      DIGITAL SECURITY / CYBER SAFETY
    </h4>
  </div>

  <div className="divide-y divide-gray-50">
    <FAQItem
      question="How safe is online investing through DreamLadder?"
      answer="Very safe. We use bank-grade encryption, secure servers, and regulatory compliance to protect your data and funds."
    />

    <FAQItem
      question="What cybersecurity measures protect my account?"
      answer="Your account is secured with encryption, firewalls, intrusion detection systems, and regular security audits."
    />

    <FAQItem
      question="How can I identify phishing or fake investment platforms?"
      answer="Always check for official domain (dreamladdercapital.com), SEBI registration, and secure HTTPS. Avoid clicking on suspicious links or sharing OTPs."
    />

    <FAQItem
      question="What should I do if I suspect fraud or hacking?"
      answer="Immediately freeze transactions, change passwords, and contact our support team. We also guide you on filing a cybercrime report if required."
    />

    <FAQItem
      question="Do you provide two-factor authentication (2FA)?"
      answer="Yes. 2FA is mandatory for account login and transactions, adding an extra layer of protection."
    />
  </div>
</section>

<section
  id="customer-support"
  className="mb-10 scroll-mt-28 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
>
  <div className="border-b border-gray-100 pb-3 mb-4">
    <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
      CUSTOMER SUPPORT
    </h4>
  </div>

  <div className="divide-y divide-gray-50">
    <FAQItem
      question="What is the best way to reach customer support?"
      answer="You can reach us via email, phone, or live chat on our website."
    />

    <FAQItem
      question="Do you provide dedicated relationship managers?"
      answer="Yes. Premium clients get a dedicated relationship manager for personalized support."
    />

    <FAQItem
      question="What are your support timings?"
      answer="Our support team is available Monday–Saturday, 9:30 AM to 7:00 PM IST."
    />

    <FAQItem
      question="How quickly can I expect a response to queries?"
      answer="We usually respond within 24 hours for standard queries and within a few hours for urgent issues."
    />

    <FAQItem
      question="Do you provide portfolio reviews on request?"
      answer="Yes. We offer periodic and on-demand portfolio reviews to keep your investments aligned with goals."
    />
  </div>
</section>

      </div>
    </div>
  );
};

export default FAQs;